import {
  FechaBodyTemplate,
  ImporteBodyTemplate,
  NumFacturaBodyTemplate,
  ActionsFacturaBodyTemplate,
  TipoDocumentoBodyTemplate,
} from "features/Documentos/templates"

import { nanoid } from "nanoid"

export const columns = [
  {
    key: nanoid(),
    header: "Núm. pedido",
    sortable: true,
    body: NumFacturaBodyTemplate,
    filter: false,
    field: "numero",
  },
  {
    key: nanoid(),
    header: "Fecha de emisión",
    sortable: true,
    filter: false,
    body: FechaBodyTemplate,
    field: "fechaEmision",
    customFilter: {
      type: "date",
      name: "fechaEmision",
    },
  },
  {
    key: nanoid(),
    header: "Tipo",
    sortable: true,
    filter: false,
    body: TipoDocumentoBodyTemplate,
    field: "tipo",
  },
  {
    key: nanoid(),
    header: "Importe",
    sortable: true,
    filter: false,
    body: ImporteBodyTemplate,
    field: "importe",
  },
  {
    key: nanoid(),
    filter: false,
    body: ActionsFacturaBodyTemplate,
    isFunctionComponent: true,
    textAlign: "center",
  },
]
